






























import {Component, Prop, Vue} from "vue-property-decorator";
import {User} from "@/types";
import FollowBtn from "@/components/user/_followBtn.vue";
import {AxiosError, AxiosResponse} from "axios";
import UserAvatar from "@/components/user/_userAvatar.vue";

@Component({
    components: {
        FollowBtn,
        UserAvatar},
})
export default class MemberCard extends Vue {
    @Prop() member!: any;
    profileImg = '';
    bannerImg = '/img/channel_banner.png'
    isOpenMyDropdown = false

    muteUser() {
        this.isOpenMyDropdown = false;
        this.$api.userBlock(this.member.id)
            .then((res: AxiosResponse) => {
                // console.log(res)
            })
            .catch((err: AxiosError) => {

            })


    }

    mounted() {
        if (this.member.profile_img) {
            this.profileImg = this.member.profile_img
        }
    }

    reFetch() {
        this.$emit('reFetch')

    }

    userPage() {
        this.$router.push(`/${this.$i18n.locale}/channel/${this.member.channel_id}/timeline`)
    }
}
